(function () {
	"use strict";

	angular
		.module("qbePortal")
		.controller("QBProgressBarController", QBProgressBarController);
	QBProgressBarController.$inject = [
		"$scope",
		"$state",
		"dynamicRouter",
		"MODULE_INFO",
		"labelService",
		"Util",
	];

	function QBProgressBarController(
		$scope,
		$state,
		dynamicRouter,
		MODULE_INFO,
		labelService,
		Util
	) {
		var vm = this;
		vm.selectedStep = null;
		vm.lastSelectedStep = null;
		vm.state = $state;

		$scope.$on("$stateChangeSuccess", function (
			event,
			toState,
			toParams,
			fromState,
			fromParams
		) {
			if (toState) {
				vm.selectedStep = toState.name;

				// hack to stop vm.selectedStep to nullifying
				if (vm.selectedStep !== vm.lastSelectedStep) {
					vm.lastSelectedStep = vm.selectedStep;
				}

				// display top banner
				displayTopBanner();
			}
		});

		$scope.$on("selected-quote-changed", function () {
			$scope.$root.$broadcast("hide-top-banner");
			displayTopBanner();
		});

		vm.getPage = function () {
			var page = vm.state.current.name.split(".")[1];

			if (page === "policy-start-date" || page === "ctp") {
				return false;
			} else {
				return true;
			}
		};

		function getStateByNumber(stepNumber) {
			var steps = dynamicRouter.getSteps();
			if (steps) return steps[stepNumber].stateName;

			return null;
		}

		function displayTopBanner() {
			var getPages = labelService.getObjectValue("topBanner", "pages");
			var bannerText = labelService.getObjectValue(
				"topBanner",
				"bannerText"
			);

			if (
				!Util.isUndefinedOrNull(getPages) &&
				!Util.isUndefinedOrNull(bannerText) &&
				bannerText != ""
			) {
				var pagesArray = getPages.split(",");
				var displayTopBanner = false;
				var declinePages = ["decline", "embargo", "referral", "error"];
				var currentPage = dynamicRouter
					.getCurrentState()
					.name.split(".");
				currentPage = currentPage[currentPage.length - 1];

				if (getPages.length > 0) {
					for (var i = 0; i < pagesArray.length; i++) {
						if (currentPage == pagesArray[i]) {
							displayTopBanner = true;
						}
					}

					for (var d = 0; d < declinePages.length; d++) {
						if (currentPage == declinePages[d]) {
							displayTopBanner = false;
						}
					}
				}

				if (displayTopBanner) {
					$scope.$root.$broadcast("show-top-banner", bannerText);
				} else {
					$scope.$root.$broadcast("hide-top-banner");
				}
			} else {
				return;
			}
		}

		vm.getSteps = function () {
			return dynamicRouter.getSteps();
		};

		vm.isCurrent = function (stepNumber) {
			return (
				getStateByNumber(stepNumber) ==
				dynamicRouter.getCurrentState().name
			);
		};

		vm.canMoveToStep = function (stepNumber) {
			return stepNumber < dynamicRouter.getCurrentState().number;
		};

		vm.moveToStep = function (stepNumber) {
			if (vm.canMoveToStep(stepNumber)) {
				$scope.$root.$broadcast("hide-top-banner");
				$state.go(getStateByNumber(stepNumber));
			}
		};

		vm.moveToSelectedStep = function () {
			if (!!vm.selectedStep) {
				$scope.$root.$broadcast("hide-top-banner");
				$state.go(vm.selectedStep);
			} else {
				// hack to stop vm.selectedStep to nullifying
				vm.selectedStep = vm.lastSelectedStep;
			}
		};
	}

	angular.module("qbePortal").component("qbProgressBar", {
		templateUrl: "../ngviews/components/qbProgressBar.html",
		controller: QBProgressBarController,
		controllerAs: "vm",
	});
})();
